import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import { AvatarProfileImageFragmentDoc, UserSelectionSetFragmentDoc } from '../../../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MarkChatReadMutationVariables = Types.Exact<{
  input: Types.MarkChatReadInput;
}>;


export type MarkChatReadMutation = { __typename?: 'Mutation', markChatRead: { __typename?: 'MarkChatReadResult', success: boolean, chat?: { __typename?: 'Chat', id: string, unreadCount: number } | null } };

export type MarkChatMessagingActivityItemsReadMutationVariables = Types.Exact<{
  chatId: Types.Scalars['UUID']['input'];
}>;


export type MarkChatMessagingActivityItemsReadMutation = { __typename?: 'Mutation', markMessagingActivityItemsRead: { __typename?: 'MessagingActivityItemsMutationResult', success: boolean } };

export type NewMessagingChatQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type NewMessagingChatQuery = { __typename?: 'Query', Chat?: { __typename?: 'Chat', id: string, chatType: Types.ChatType, viewerIsOwner: boolean, membersCanEditTitle: boolean, membersCanEditMembers: boolean, viewerArchivedAt?: string | null, createdAt: string, title?: { __typename?: 'TranslationSet', en: string } | null, createdBy: { __typename?: 'Employee', id: number, name: string }, owners: Array<{ __typename?: 'Employee', id: number, name: string, firstName: string, deactivatedAt?: string | null, userType: Types.UserType, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null, roles: Array<{ __typename?: 'Role', id: number, name: string }>, locations: Array<{ __typename?: 'Location', id: number, name: string }> }>, userSelectionSet: { __typename?: 'UserSelectionSet', id: string, userSelections: Array<{ __typename?: 'UserSelection', id: number, allLocations: boolean, allTrainees: boolean, allManagers: boolean, allAdmins: boolean, everyoneAtOrgOrBrand: boolean, daysAfterHire?: number | null, userMemberships: Array<{ __typename?: 'UserSelectionUser', id: number, user: { __typename?: 'Employee', id: number, name: string } }>, locationMemberships: Array<{ __typename?: 'UserSelectionLocation', id: number, location: { __typename?: 'Location', id: number, name: string } }>, roleMemberships: Array<{ __typename?: 'UserSelectionRole', id: number, role: { __typename?: 'Role', id: number, name: string } }>, locationGroupMemberships: Array<{ __typename?: 'UserSelectionLocationGroup', id: string, locationGroup: { __typename?: 'LocationGroup', id: string, name: string, type: Types.LocationGroupType } }>, roleGroupMemberships: Array<{ __typename?: 'UserSelectionRoleGroup', id: string, roleGroup: { __typename?: 'RoleGroup', id: string, name: string } }> }> }, members: Array<{ __typename?: 'Employee', id: number, name: string, firstName: string, deactivatedAt?: string | null, userType: Types.UserType, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null, roles: Array<{ __typename?: 'Role', id: number, name: string }>, locations: Array<{ __typename?: 'Location', id: number, name: string }> }> } | null };

export type ChatDetailFragment = { __typename?: 'Chat', id: string, chatType: Types.ChatType, viewerIsOwner: boolean, membersCanEditTitle: boolean, membersCanEditMembers: boolean, viewerArchivedAt?: string | null, createdAt: string, title?: { __typename?: 'TranslationSet', en: string } | null, createdBy: { __typename?: 'Employee', id: number, name: string }, owners: Array<{ __typename?: 'Employee', id: number, name: string, firstName: string, deactivatedAt?: string | null, userType: Types.UserType, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null, roles: Array<{ __typename?: 'Role', id: number, name: string }>, locations: Array<{ __typename?: 'Location', id: number, name: string }> }>, userSelectionSet: { __typename?: 'UserSelectionSet', id: string, userSelections: Array<{ __typename?: 'UserSelection', id: number, allLocations: boolean, allTrainees: boolean, allManagers: boolean, allAdmins: boolean, everyoneAtOrgOrBrand: boolean, daysAfterHire?: number | null, userMemberships: Array<{ __typename?: 'UserSelectionUser', id: number, user: { __typename?: 'Employee', id: number, name: string } }>, locationMemberships: Array<{ __typename?: 'UserSelectionLocation', id: number, location: { __typename?: 'Location', id: number, name: string } }>, roleMemberships: Array<{ __typename?: 'UserSelectionRole', id: number, role: { __typename?: 'Role', id: number, name: string } }>, locationGroupMemberships: Array<{ __typename?: 'UserSelectionLocationGroup', id: string, locationGroup: { __typename?: 'LocationGroup', id: string, name: string, type: Types.LocationGroupType } }>, roleGroupMemberships: Array<{ __typename?: 'UserSelectionRoleGroup', id: string, roleGroup: { __typename?: 'RoleGroup', id: string, name: string } }> }> }, members: Array<{ __typename?: 'Employee', id: number, name: string, firstName: string, deactivatedAt?: string | null, userType: Types.UserType, profileImage?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, thumb?: string | null, medium?: string | null, original: string } | null } | null, roles: Array<{ __typename?: 'Role', id: number, name: string }>, locations: Array<{ __typename?: 'Location', id: number, name: string }> }> };

export const ChatDetailFragmentDoc = gql`
    fragment ChatDetail on Chat {
  id
  chatType
  viewerIsOwner
  membersCanEditTitle
  membersCanEditMembers
  title {
    en
  }
  viewerArchivedAt
  createdAt
  createdBy {
    id
    name
  }
  owners {
    id
    name
    firstName
    deactivatedAt
    userType
    profileImage {
      ...AvatarProfileImage
    }
    roles {
      id
      name
    }
    locations {
      id
      name
    }
  }
  userSelectionSet {
    ...UserSelectionSet
  }
  members {
    id
    name
    firstName
    deactivatedAt
    userType
    profileImage {
      ...AvatarProfileImage
    }
    roles {
      id
      name
    }
    locations {
      id
      name
    }
  }
}
    ${AvatarProfileImageFragmentDoc}
${UserSelectionSetFragmentDoc}`;
export const MarkChatReadDocument = gql`
    mutation MarkChatRead($input: MarkChatReadInput!) {
  markChatRead(input: $input) {
    success
    chat {
      id
      unreadCount
    }
  }
}
    `;
export type MarkChatReadMutationFn = Apollo.MutationFunction<MarkChatReadMutation, MarkChatReadMutationVariables>;

/**
 * __useMarkChatReadMutation__
 *
 * To run a mutation, you first call `useMarkChatReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkChatReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markChatReadMutation, { data, loading, error }] = useMarkChatReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkChatReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkChatReadMutation, MarkChatReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkChatReadMutation, MarkChatReadMutationVariables>(MarkChatReadDocument, options);
      }
export type MarkChatReadMutationHookResult = ReturnType<typeof useMarkChatReadMutation>;
export type MarkChatReadMutationResult = Apollo.MutationResult<MarkChatReadMutation>;
export type MarkChatReadMutationOptions = Apollo.BaseMutationOptions<MarkChatReadMutation, MarkChatReadMutationVariables>;
export const MarkChatMessagingActivityItemsReadDocument = gql`
    mutation MarkChatMessagingActivityItemsRead($chatId: UUID!) {
  markMessagingActivityItemsRead(
    input: {chatIds: [$chatId], types: [NEW_CHAT_MESSAGE, CHAT_MESSAGE_MENTION, CHAT_OWNER_ADDED, CHAT_OWNER_REMOVED]}
  ) {
    success
  }
}
    `;
export type MarkChatMessagingActivityItemsReadMutationFn = Apollo.MutationFunction<MarkChatMessagingActivityItemsReadMutation, MarkChatMessagingActivityItemsReadMutationVariables>;

/**
 * __useMarkChatMessagingActivityItemsReadMutation__
 *
 * To run a mutation, you first call `useMarkChatMessagingActivityItemsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkChatMessagingActivityItemsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markChatMessagingActivityItemsReadMutation, { data, loading, error }] = useMarkChatMessagingActivityItemsReadMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useMarkChatMessagingActivityItemsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkChatMessagingActivityItemsReadMutation, MarkChatMessagingActivityItemsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkChatMessagingActivityItemsReadMutation, MarkChatMessagingActivityItemsReadMutationVariables>(MarkChatMessagingActivityItemsReadDocument, options);
      }
export type MarkChatMessagingActivityItemsReadMutationHookResult = ReturnType<typeof useMarkChatMessagingActivityItemsReadMutation>;
export type MarkChatMessagingActivityItemsReadMutationResult = Apollo.MutationResult<MarkChatMessagingActivityItemsReadMutation>;
export type MarkChatMessagingActivityItemsReadMutationOptions = Apollo.BaseMutationOptions<MarkChatMessagingActivityItemsReadMutation, MarkChatMessagingActivityItemsReadMutationVariables>;
export const NewMessagingChatDocument = gql`
    query NewMessagingChat($id: UUID!) {
  Chat(id: $id) {
    ...ChatDetail
  }
}
    ${ChatDetailFragmentDoc}`;

/**
 * __useNewMessagingChatQuery__
 *
 * To run a query within a React component, call `useNewMessagingChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewMessagingChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewMessagingChatQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNewMessagingChatQuery(baseOptions: Apollo.QueryHookOptions<NewMessagingChatQuery, NewMessagingChatQueryVariables> & ({ variables: NewMessagingChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewMessagingChatQuery, NewMessagingChatQueryVariables>(NewMessagingChatDocument, options);
      }
export function useNewMessagingChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewMessagingChatQuery, NewMessagingChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewMessagingChatQuery, NewMessagingChatQueryVariables>(NewMessagingChatDocument, options);
        }
export type NewMessagingChatQueryHookResult = ReturnType<typeof useNewMessagingChatQuery>;
export type NewMessagingChatLazyQueryHookResult = ReturnType<typeof useNewMessagingChatLazyQuery>;
export type NewMessagingChatQueryResult = Apollo.QueryResult<NewMessagingChatQuery, NewMessagingChatQueryVariables>;